import { ReactComponent as PointCloud } from "./ic_point-cloud.svg";
import { ReactComponent as BlockModel } from "./ic_block-model.svg";
import { ReactComponent as Mesh } from "./ic_geo-mesh.svg";
import { ReactComponent as MeshSet } from "./Icon_Mesh-Set.svg";
import { ReactComponent as Vector } from "./ic_geo-vector.svg";
import { ReactComponent as DrillHoles } from "./ic_drillholes.svg";
import { ReactComponent as Raster } from "./ic_raster.svg";

export const SliceAll = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="ic_slice-all" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Group-46">
                        <g>
                            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                            <g id="Group-39" fill="#96A9CB" stroke="#434343" strokeLinejoin="round">
                                <polygon
                                    id="Rectangle-Copy-6"
                                    transform="translate(11.607604, 12.047111) scale(-1, 1) rotate(-360.000000) translate(-11.607604, -12.047111) "
                                    points="3.89331848 11.189968 3.89331848 4.33282511 19.3218899 4.33282511 19.3218899 19.7613965 12.5598151 19.7613965 3.89331848 19.7613965"
                                ></polygon>
                                <rect
                                    id="Rectangle-Copy-7"
                                    x="3.89331848"
                                    y="4.33282511"
                                    width="8.57142857"
                                    height="8.57142857"
                                ></rect>
                                <polygon
                                    id="Path-4-Copy"
                                    transform="translate(9.732452, 3.428571) scale(-1, 1) rotate(-315.000000) translate(-9.732452, -3.428571) "
                                    points="8.50074608 6 8.50074608 0.857142857 10.9641571 3.42857143"
                                ></polygon>
                                <polygon
                                    id="Path-4-Copy-2"
                                    transform="translate(2.945991, 10.215032) rotate(-45.000000) translate(-2.945991, -10.215032) "
                                    points="1.71428571 12.7864604 1.87918985 7.64360322 4.17769669 10.2150318"
                                ></polygon>
                                <polygon
                                    id="Path-4-Copy-3"
                                    transform="translate(13.944045, 10.112231) scale(-1, 1) rotate(-315.000000) translate(-13.944045, -10.112231) "
                                    points="16.951187 10.9603438 16.951187 15.2784038 10.951187 9.38554667 10.9369023 4.94605901"
                                ></polygon>
                                <polygon
                                    id="Path-4-Copy-4"
                                    transform="translate(9.765646, 14.290630) rotate(-45.000000) translate(-9.765646, -14.290630) "
                                    points="12.7727884 15.1387424 12.7727884 19.4568024 6.77278839 13.5639453 6.75850365 9.12445763"
                                ></polygon>
                                <polygon
                                    id="Path-2-Copy"
                                    transform="translate(14.542994, 18.796570) scale(1, -1) rotate(-315.000000) translate(-14.542994, -18.796570) "
                                    points="17.239948 20.2078096 11.8460396 14.8139012 11.8460396 19.9567583 14.6685195 22.7792382"
                                ></polygon>
                                <polygon
                                    id="Path-2-Copy-2"
                                    transform="translate(18.398879, 14.940684) scale(-1, -1) rotate(-45.000000) translate(-18.398879, -14.940684) "
                                    points="21.0366965 16.3519243 15.7610617 10.9580159 15.7610617 16.100873 18.465268 18.9233529"
                                ></polygon>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const SliceFront = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g
                    id="ic_slice-front"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinejoin="round"
                >
                    <g stroke="#434343">
                        <polygon
                            id="Rectangle-Copy-22"
                            fill="#96A9CB"
                            transform="translate(11.607604, 12.047111) scale(-1, 1) rotate(-360.000000) translate(-11.607604, -12.047111) "
                            points="3.89331848 11.189968 3.89331848 4.33282511 19.3218899 4.33282511 19.3218899 19.7613965 12.5598151 19.7613965 3.89331848 19.7613965"
                        ></polygon>
                        <polygon
                            id="Path-4-Copy-9"
                            fill="#FFFFFF"
                            transform="translate(9.732452, 3.428571) scale(-1, 1) rotate(-315.000000) translate(-9.732452, -3.428571) "
                            points="8.50074608 6 8.50074608 0.857142857 10.9641571 3.42857143"
                        ></polygon>
                        <polygon
                            id="Path-4-Copy-10"
                            fill="#FFFFFF"
                            transform="translate(2.945991, 10.215032) rotate(-45.000000) translate(-2.945991, -10.215032) "
                            points="1.71428571 12.7864604 1.87918985 7.64360322 4.17769669 10.2150318"
                        ></polygon>
                        <polygon
                            id="Path-4-Copy-11"
                            fill="#FFFFFF"
                            transform="translate(13.944045, 10.112231) scale(-1, 1) rotate(-315.000000) translate(-13.944045, -10.112231) "
                            points="16.951187 10.9603438 16.951187 15.2784038 10.951187 9.38554667 10.9369023 4.94605901"
                        ></polygon>
                        <polygon
                            id="Path-4-Copy-12"
                            fill="#FFFFFF"
                            transform="translate(9.765646, 14.290630) rotate(-45.000000) translate(-9.765646, -14.290630) "
                            points="12.7727884 15.1387424 12.7727884 19.4568024 6.77278839 13.5639453 6.75850365 9.12445763"
                        ></polygon>
                        <polygon
                            id="Path-2-Copy-5"
                            fill="#FFFFFF"
                            transform="translate(14.542994, 18.796570) scale(1, -1) rotate(-315.000000) translate(-14.542994, -18.796570) "
                            points="17.239948 20.2078096 11.8460396 14.8139012 11.8460396 19.9567583 14.6685195 22.7792382"
                        ></polygon>
                        <polygon
                            id="Path-2-Copy-6"
                            fill="#FFFFFF"
                            transform="translate(18.398879, 14.940684) scale(-1, -1) rotate(-45.000000) translate(-18.398879, -14.940684) "
                            points="21.0366965 16.3519243 15.7610617 10.9580159 15.7610617 16.100873 18.465268 18.9233529"
                        ></polygon>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const SliceSide = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g
                    id="ic_slice-side"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinejoin="round"
                >
                    <g stroke="#434343">
                        <polygon
                            id="Rectangle-Copy-16"
                            fill="#FFFFFF"
                            transform="translate(11.607604, 12.047111) scale(-1, 1) rotate(-360.000000) translate(-11.607604, -12.047111) "
                            points="3.89331848 11.189968 3.89331848 4.33282511 19.3218899 4.33282511 19.3218899 19.7613965 12.5598151 19.7613965 3.89331848 19.7613965"
                        ></polygon>
                        <rect
                            id="Rectangle-Copy-21"
                            fill="#FFFFFF"
                            x="3.89331848"
                            y="4.33282511"
                            width="8.57142857"
                            height="8.57142857"
                        ></rect>
                        <polygon
                            id="Path-4-Copy-5"
                            fill="#99A9C8"
                            transform="translate(9.732452, 3.428571) scale(-1, 1) rotate(-315.000000) translate(-9.732452, -3.428571) "
                            points="8.50074608 6 8.50074608 0.857142857 10.9641571 3.42857143"
                        ></polygon>
                        <polygon
                            id="Path-4-Copy-6"
                            fill="#FFFFFF"
                            transform="translate(2.945991, 10.215032) rotate(-45.000000) translate(-2.945991, -10.215032) "
                            points="1.71428571 12.7864604 1.87918985 7.64360322 4.17769669 10.2150318"
                        ></polygon>
                        <polygon
                            id="Path-4-Copy-7"
                            fill="#99A9C8"
                            transform="translate(13.944045, 10.112231) scale(-1, 1) rotate(-315.000000) translate(-13.944045, -10.112231) "
                            points="16.951187 10.9603438 16.951187 15.2784038 10.951187 9.38554667 10.9369023 4.94605901"
                        ></polygon>
                        <polygon
                            id="Path-4-Copy-8"
                            fill="#FFFFFF"
                            transform="translate(9.765646, 14.290630) rotate(-45.000000) translate(-9.765646, -14.290630) "
                            points="12.7727884 15.1387424 12.7727884 19.4568024 6.77278839 13.5639453 6.75850365 9.12445763"
                        ></polygon>
                        <polygon
                            id="Path-2-Copy-3"
                            fill="#99A9C8"
                            transform="translate(14.542994, 18.796570) scale(1, -1) rotate(-315.000000) translate(-14.542994, -18.796570) "
                            points="17.239948 20.2078096 11.8460396 14.8139012 11.8460396 19.9567583 14.6685195 22.7792382"
                        ></polygon>
                        <polygon
                            id="Path-2-Copy-4"
                            fill="#FFFFFF"
                            transform="translate(18.398879, 14.940684) scale(-1, -1) rotate(-45.000000) translate(-18.398879, -14.940684) "
                            points="21.0366965 16.3519243 15.7610617 10.9580159 15.7610617 16.100873 18.465268 18.9233529"
                        ></polygon>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const SliceFrontBackward = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="ic_slice-front-backward" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Group-44">
                        <g>
                            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                            <g
                                id="Group-33"
                                transform="translate(3.000000, 3.000000)"
                                stroke="#434343"
                                strokeLinejoin="round"
                            >
                                <polygon
                                    id="Rectangle-Copy-22"
                                    fill="#99A9C8"
                                    transform="translate(7.740000, 7.740000) scale(-1, 1) rotate(-360.000000) translate(-7.740000, -7.740000) "
                                    points="0 6.88 0 0 15.48 0 15.48 15.48 8.69538492 15.48 0 15.48"
                                ></polygon>
                                <rect id="Rectangle" fill="#FFFFFF" x="8.6" y="8.6" width="8.6" height="8.6"></rect>
                                <polygon
                                    id="Path-7"
                                    fill="#FFFFFF"
                                    points="11.5341176 3.44 17.2 8.6 8.6 8.6 3.44 3.44"
                                ></polygon>
                                <polygon
                                    id="Path-8"
                                    fill="#FFFFFF"
                                    points="8.6 17.2 3.44 11.5341176 3.44 3.44 8.6 8.6"
                                ></polygon>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const SliceFrontForward = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="ic_slice-front-forward" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Group-14">
                        <g>
                            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                            <g id="Group-45" transform="translate(3.000000, 2.000000)" stroke="#434343">
                                <g id="Group-36">
                                    <g id="Group-33-Copy" fill="#FFFFFF" strokeLinejoin="round" strokeWidth="0.86">
                                        <rect id="Rectangle" x="5.16" y="5.16" width="8.6" height="8.6"></rect>
                                        <polygon id="Path-7" points="8.09411765 0 13.76 5.16 5.16 5.16 0 0"></polygon>
                                        <polygon id="Path-8" points="5.16 13.76 0 8.09411765 0 0 5.16 5.16"></polygon>
                                    </g>
                                    <polygon
                                        id="Rectangle-Copy-22"
                                        fill="#99A9C8"
                                        strokeLinejoin="round"
                                        transform="translate(10.320000, 10.320000) scale(-1, 1) rotate(-360.000000) translate(-10.320000, -10.320000) "
                                        points="2.58 9.46 2.58 2.58 18.06 2.58 18.06 18.06 11.2753849 18.06 2.58 18.06"
                                    ></polygon>
                                    <polygon
                                        id="Rectangle-Copy-22"
                                        fill="#FFFFFF"
                                        strokeLinejoin="round"
                                        transform="translate(10.320000, 10.320000) scale(-1, 1) rotate(-360.000000) translate(-10.320000, -10.320000) "
                                        points="6.02 9.84222222 6.02 6.02 14.62 6.02 14.62 14.62 10.8507694 14.62 6.02 14.62"
                                    ></polygon>
                                    <polyline
                                        id="Path-10"
                                        points="11.18 6.40991145 11.18 11.0114899 6.02 11.0114899"
                                    ></polyline>
                                    <line x1="11.18" y1="11.0114899" x2="14.7885101" y2="14.62" id="Path-11"></line>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const SliceHor = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g
                    id="ic_slice-hor"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinejoin="round"
                >
                    <g stroke="#434343">
                        <polygon
                            id="Rectangle-Copy-24"
                            fill="#FFFFFF"
                            transform="translate(11.607604, 12.047111) scale(-1, 1) rotate(-360.000000) translate(-11.607604, -12.047111) "
                            points="3.89331848 11.189968 3.89331848 4.33282511 19.3218899 4.33282511 19.3218899 19.7613965 12.5598151 19.7613965 3.89331848 19.7613965"
                        ></polygon>
                        <rect
                            id="Rectangle-Copy-25"
                            fill="#FFFFFF"
                            x="3.89331848"
                            y="4.33282511"
                            width="8.57142857"
                            height="8.57142857"
                        ></rect>
                        <polygon
                            id="Path-4-Copy-13"
                            fill="#FFFFFF"
                            transform="translate(9.732452, 3.428571) scale(-1, 1) rotate(-315.000000) translate(-9.732452, -3.428571) "
                            points="8.50074608 6 8.50074608 0.857142857 10.9641571 3.42857143"
                        ></polygon>
                        <polygon
                            id="Path-4-Copy-14"
                            fill="#99A9C8"
                            transform="translate(2.945991, 10.215032) rotate(-45.000000) translate(-2.945991, -10.215032) "
                            points="1.71428571 12.7864604 1.87918985 7.64360322 4.17769669 10.2150318"
                        ></polygon>
                        <polygon
                            id="Path-4-Copy-15"
                            fill="#FFFFFF"
                            transform="translate(13.944045, 10.112231) scale(-1, 1) rotate(-315.000000) translate(-13.944045, -10.112231) "
                            points="16.951187 10.9603438 16.951187 15.2784038 10.951187 9.38554667 10.9369023 4.94605901"
                        ></polygon>
                        <polygon
                            id="Path-4-Copy-16"
                            fill="#99A9C8"
                            transform="translate(9.765646, 14.290630) rotate(-45.000000) translate(-9.765646, -14.290630) "
                            points="12.7727884 15.1387424 12.7727884 19.4568024 6.77278839 13.5639453 6.75850365 9.12445763"
                        ></polygon>
                        <polygon
                            id="Path-2-Copy-7"
                            fill="#FFFFFF"
                            transform="translate(14.542994, 18.796570) scale(1, -1) rotate(-315.000000) translate(-14.542994, -18.796570) "
                            points="17.239948 20.2078096 11.8460396 14.8139012 11.8460396 19.9567583 14.6685195 22.7792382"
                        ></polygon>
                        <polygon
                            id="Path-2-Copy-8"
                            fill="#99A9C8"
                            transform="translate(18.398879, 14.940684) scale(-1, -1) rotate(-45.000000) translate(-18.398879, -14.940684) "
                            points="21.0366965 16.3519243 15.7610617 10.9580159 15.7610617 16.100873 18.465268 18.9233529"
                        ></polygon>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const SliceHorBottom = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="ic_slice-hor-bottom" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Group-34-Copy" stroke="#434343">
                        <g transform="translate(12.000000, 12.000000) scale(-1, 1) rotate(-270.000000) translate(-12.000000, -12.000000) ">
                            <g
                                id="Group-32-Copy"
                                transform="translate(11.999911, 6.020000)"
                                fill="#FFFFFF"
                                strokeLinejoin="round"
                            >
                                <g id="Group-24" transform="translate(0.000000, 0.035952)">
                                    <polygon
                                        id="Path-3"
                                        points="6.11410218 -4.88853402e-14 1.42836853e-13 -4.88853402e-14 3.05705109 3.05705109 9.20315699 3.05705109"
                                    ></polygon>
                                    <polygon
                                        id="Path-5"
                                        points="9.20315699 3.05705109 9.20315699 11.8232145 3.08510012 11.8232145 3.08510012 3.05705109"
                                    ></polygon>
                                    <polygon
                                        id="Path-6"
                                        points="-8.56287296e-17 4.88853402e-14 -8.56287296e-17 8.60353728 3.08510012 11.8232145 3.08510012 3.05705109"
                                    ></polygon>
                                </g>
                            </g>
                            <polygon
                                id="Path-4"
                                fill="#99A9C8"
                                strokeLinejoin="round"
                                transform="translate(11.709069, 12.199409) scale(-1, 1) rotate(-315.000000) translate(-11.709069, -12.199409) "
                                points="17.3981382 22.6788188 6.02 11.3006807 6.03318065 1.72 17.2596153 12.9464346"
                            ></polygon>
                            <polygon
                                id="Path-4"
                                fill="#FFFFFF"
                                strokeLinejoin="round"
                                transform="translate(11.710780, 12.217907) scale(-1, 1) rotate(-315.000000) translate(-11.710780, -12.217907) "
                                points="15.1546803 18.2521971 8.4243633 11.5218801 8.26687924 6.18361773 14.8440918 12.7608303"
                            ></polygon>
                            <line x1="9.8409604" y1="14.6696466" x2="13.5424615" y2="14.6696466" id="Path-9"></line>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const SliceHorTop = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g
                    id="ic_slice-hore-top"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinejoin="round"
                >
                    <g id="Group-32" stroke="#434343">
                        <g transform="translate(12.000000, 12.000000) scale(-1, 1) rotate(-270.000000) translate(-12.000000, -12.000000) ">
                            <polyline
                                id="Path-4"
                                fill="#99A9C8"
                                transform="translate(11.749158, 12.199409) scale(-1, 1) rotate(-315.000000) translate(-11.749158, -12.199409) "
                                points="17.2274387 14.8540171 17.4382267 22.6788188 6.06008855 11.3006807 6.0732692 1.72 9.78141582 5.42814662"
                            ></polyline>
                            <g id="Group-24" transform="translate(4.300000, 6.055952)" fill="#FFFFFF">
                                <polygon
                                    id="Path-3"
                                    points="6.11410218 -4.88853402e-14 1.42836853e-13 -4.88853402e-14 3.05705109 3.05705109 9.20315699 3.05705109"
                                ></polygon>
                                <polygon
                                    id="Path-5"
                                    points="9.20315699 3.05705109 9.20315699 11.8232145 3.08510012 11.8232145 3.08510012 3.05705109"
                                ></polygon>
                                <polygon
                                    id="Path-6"
                                    points="-8.56287296e-17 4.88853402e-14 -8.56287296e-17 8.60353728 3.08510012 11.8232145 3.08510012 3.05705109"
                                ></polygon>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const SliceManual = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="ic_slice-manual" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Group">
                        <g>
                            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                            <g id="Group-8">
                                <g id="cs/none" transform="translate(3.000000, 0.000000)" stroke="#434343">
                                    <g id="Group-3" transform="translate(9.000000, 0.000000)" fill="#FFFFFF">
                                        <path
                                            d="M9.16344344,2.90578052 L1.66344344,3.40578052 L1.66344344,7.90578052 L9.66344344,7.90578052 L9.16344344,2.90578052 Z"
                                            id="Rectangle"
                                            transform="translate(5.663443, 5.405781) rotate(-140.000000) translate(-5.663443, -5.405781) "
                                        ></path>
                                    </g>
                                    <polygon
                                        id="Path"
                                        fill="#99A9C8"
                                        points="11.4160658 13.9569425 0.972457884 17.719346 7.72686234 8.80947471 11.0042804 5.71934596 14.9724579 8.93513995"
                                    ></polygon>
                                </g>
                                <path
                                    d="M0.5,22 L0.5,23 L3.5,23 L3.5,22 L0.5,22 Z M4.5,22 L4.5,23 L7.5,23 L7.5,22 L4.5,22 Z M8.5,22 L8.5,23 L11.5,23 L11.5,22 L8.5,22 Z M12.5,22 L12.5,23 L15.5,23 L15.5,22 L12.5,22 Z M16.5,22 L16.5,23 L19.5,23 L19.5,22 L16.5,22 Z M20.5,22 L20.5,23 L23.04,23 L23.04,22 L20.5,22 Z"
                                    id="Line"
                                    fill="currentColor"
                                    fillRule="nonzero"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const SliceNone = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g
                    id="ic_slice-none"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinejoin="round"
                >
                    <g fill="#FFFFFF" id="Group-37" stroke="#434343">
                        <g>
                            <polygon
                                id="Rectangle"
                                strokeWidth="0.857142857"
                                transform="translate(11.607604, 12.047111) scale(-1, 1) rotate(-360.000000) translate(-11.607604, -12.047111) "
                                points="3.89331848 11.189968 3.89331848 4.33282511 19.3218899 4.33282511 19.3218899 19.7613965 12.5598151 19.7613965 3.89331848 19.7613965"
                            ></polygon>
                            <rect
                                id="Rectangle"
                                x="3.89331848"
                                y="4.33282511"
                                width="8.57142857"
                                height="8.57142857"
                            ></rect>
                            <polygon
                                id="Path-4"
                                transform="translate(9.732452, 3.428571) scale(-1, 1) rotate(-315.000000) translate(-9.732452, -3.428571) "
                                points="8.50074608 6 8.50074608 0.857142857 10.9641571 3.42857143"
                            ></polygon>
                            <polygon
                                id="Path-4"
                                transform="translate(2.945991, 10.215032) rotate(-45.000000) translate(-2.945991, -10.215032) "
                                points="1.71428571 12.7864604 1.87918985 7.64360322 4.17769669 10.2150318"
                            ></polygon>
                            <polygon
                                id="Path-4"
                                transform="translate(13.944045, 10.112231) scale(-1, 1) rotate(-315.000000) translate(-13.944045, -10.112231) "
                                points="16.951187 10.9603438 16.951187 15.2784038 10.951187 9.38554667 10.9369023 4.94605901"
                            ></polygon>
                            <polygon
                                id="Path-4"
                                transform="translate(9.765646, 14.290630) rotate(-45.000000) translate(-9.765646, -14.290630) "
                                points="12.7727884 15.1387424 12.7727884 19.4568024 6.77278839 13.5639453 6.75850365 9.12445763"
                            ></polygon>
                            <polygon
                                id="Path-2"
                                transform="translate(14.542994, 18.796570) scale(1, -1) rotate(-315.000000) translate(-14.542994, -18.796570) "
                                points="17.239948 20.2078096 11.8460396 14.8139012 11.8460396 19.9567583 14.6685195 22.7792382"
                            ></polygon>
                            <polygon
                                id="Path-2"
                                transform="translate(18.398879, 14.940684) scale(-1, -1) rotate(-45.000000) translate(-18.398879, -14.940684) "
                                points="21.0366965 16.3519243 15.7610617 10.9580159 15.7610617 16.100873 18.465268 18.9233529"
                            ></polygon>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const SliceSideLeft = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g
                    id="ic_slice-side-left"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinejoin="round"
                >
                    <g id="Group-32" stroke="#434343">
                        <g>
                            <polyline
                                id="Path-4"
                                fill="#99A9C8"
                                transform="translate(11.710124, 12.158880) scale(-1, 1) rotate(-315.000000) translate(-11.710124, -12.158880) "
                                points="17.1702047 14.8046682 17.3802924 22.6034739 6.03995536 11.2631369 6.05309223 1.71428571 9.74891943 5.41011291"
                            ></polyline>
                            <g id="Group-24" transform="translate(4.285714, 6.035833)" fill="#FFFFFF">
                                <polygon
                                    id="Path-3"
                                    points="6.09378955 -4.87229305e-14 1.42362312e-13 -4.87229305e-14 3.04689478 3.04689478 9.17258172 3.04689478"
                                ></polygon>
                                <polygon
                                    id="Path-5"
                                    points="9.17258172 3.04689478 9.17258172 11.7839347 3.07485062 11.7839347 3.07485062 3.04689478"
                                ></polygon>
                                <polygon
                                    id="Path-6"
                                    points="-8.53442488e-17 4.87229305e-14 -8.53442488e-17 8.5749541 3.07485062 11.7839347 3.07485062 3.04689478"
                                ></polygon>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const SliceSideRight = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="ic_slice-side-right" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Group-34" stroke="#434343">
                        <g>
                            <g
                                id="Group-32-Copy"
                                transform="translate(11.999911, 6.020000)"
                                fill="#FFFFFF"
                                strokeLinejoin="round"
                                strokeWidth="0.86"
                            >
                                <g id="Group-24" transform="translate(0.000000, 0.035952)">
                                    <polygon
                                        id="Path-3"
                                        points="6.11410218 -4.88853402e-14 1.42836853e-13 -4.88853402e-14 3.05705109 3.05705109 9.20315699 3.05705109"
                                    ></polygon>
                                    <polygon
                                        id="Path-5"
                                        points="9.20315699 3.05705109 9.20315699 11.8232145 3.08510012 11.8232145 3.08510012 3.05705109"
                                    ></polygon>
                                    <polygon
                                        id="Path-6"
                                        points="-8.56287296e-17 4.88853402e-14 -8.56287296e-17 8.60353728 3.08510012 11.8232145 3.08510012 3.05705109"
                                    ></polygon>
                                </g>
                            </g>
                            <polygon
                                id="Path-4"
                                fill="#99A9C8"
                                strokeLinejoin="round"
                                transform="translate(11.709069, 12.199409) scale(-1, 1) rotate(-315.000000) translate(-11.709069, -12.199409) "
                                points="17.3981382 22.6788188 6.02 11.3006807 6.03318065 1.72 17.2596153 12.9464346"
                            ></polygon>
                            <polygon
                                id="Path-4"
                                fill="#FFFFFF"
                                strokeLinejoin="round"
                                transform="translate(11.710780, 12.217907) scale(-1, 1) rotate(-315.000000) translate(-11.710780, -12.217907) "
                                points="15.1546803 18.2521971 8.4243633 11.5218801 8.26687924 6.18361773 14.8440918 12.7608303"
                            ></polygon>
                            <line x1="9.8409604" y1="14.6696466" x2="13.5424615" y2="14.6696466" id="Path-9"></line>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const SliceToolIcon = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="ic_slice-tool-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        id="ic_tools/-slice"
                        transform="translate(12.000000, 12.000000) rotate(-360.000000) translate(-12.000000, -12.000000) translate(-0.000000, 0.000000)"
                    >
                        <g id="ic_slice" transform="translate(-0.000000, 0.000000)">
                            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                            <path
                                d="M15.449932,1 L23.8764209,8.07066371 L20.0196952,12.6669304 C19.3096916,13.5130797 18.0481804,13.6234476 17.2020311,12.913444 L17.2020311,12.913444 L17.165,12.882 L13.6573945,17.9383655 L0,22.9610685 L8.77362599,11.1579814 L11.7289046,8.31378446 C10.9852322,7.59010253 10.9154756,6.40395465 11.5932063,5.59626666 L11.5932063,5.59626666 L15.449932,1 Z M15.6963498,3.81846819 L13.1252952,6.88184188 L18.4876063,11.3813551 L21.0586609,8.31798146 L15.6963498,3.81846819 Z"
                                id="Path"
                                fill="currentColor"
                                fillRule="nonzero"
                            ></path>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const AlignToView = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="cs/-align-to-view" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <path
                        d="M21,4 L21,20 L19,20 L19,4 L21,4 Z M11.2668,4.9998 L11.2668,7.3328 C8.6908,7.3328 6.5998,9.4238 6.5998,11.9998 C6.5998,14.5758 8.6908,16.6668 11.2668,16.6668 L11.2668,16.6668 L11.2668,18.9998 C6.5998,18.9998 2.6148,16.0978 0.9998,11.9998 C2.6148,7.9028 6.5998,4.9998 11.2668,4.9998 L11.2668,4.9998 Z M11.267,9.1998 L11.267,14.7998 C9.717,14.7998 8.467,13.5488 8.467,11.9998 C8.467,10.4508 9.717,9.1998 11.267,9.1998 L11.267,9.1998 Z M14.48,11.52 L14.48,12.48 L11.52,12.48 L11.52,11.52 L14.48,11.52 Z M18.48,11.52 L18.48,12.48 L15.52,12.48 L15.52,11.52 L18.48,11.52 Z"
                        id="-?Color"
                        fill="currentColor"
                    ></path>
                </g>
            </svg>
        </div>
    );
};

export const Ortho = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="ic_ortho" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g>
                        <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                        <polygon
                            id="Polygon-2"
                            fill="currentColor"
                            points="11.660254 2 20.3205081 7 20.3205081 17 11.660254 22 3 17 3 7"
                        ></polygon>
                        <polygon
                            id="Path-20"
                            fill="#FFFFFF"
                            points="11.660254 3 3.8660254 7.5 11.660254 12 19.4544827 7.5"
                        ></polygon>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const Pers = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="ic_pers" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g>
                        <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                        <polygon
                            id="Path-15"
                            fill="currentColor"
                            points="2 5.72727273 12.9090909 3 22 3 22 12.0909091 16.5454545 20.2727273 2 20.2727273"
                        ></polygon>
                        <rect
                            id="Rectangle"
                            fill="#FFFFFF"
                            x="3.00227273"
                            y="7.00909091"
                            width="12.0272727"
                            height="12.0272727"
                        ></rect>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const North = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="icon/social/N" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        id="Icon/24px/Layers-Copy-5"
                        transform="translate(17.000000, 13.646447) rotate(-45.000000) translate(-17.000000, -13.646447) translate(9.000000, 7.146447)"
                        fill="currentColor"
                    >
                        <polygon
                            id="-↳Color"
                            transform="translate(7.920644, 6.503977) rotate(-270.000000) translate(-7.920644, -6.503977) "
                            points="7.92064393 -1.4126894 1.67064393 13.8289773 2.2623106 14.4206439 7.92064393 11.9206439 13.5789773 14.4206439 14.1706439 13.8289773"
                        ></polygon>
                    </g>
                    <polygon
                        id="N"
                        fill="currentColor"
                        fillRule="nonzero"
                        transform="translate(5.958984, 6.989258) rotate(-360.000000) translate(-5.958984, -6.989258) "
                        points="3.86376953 12 3.86376953 5.46484375 7.90380859 12 9.93408203 12 9.93408203 1.97851563 8.05419922 1.97851563 8.05419922 8.67089844 3.95263672 1.97851563 1.98388672 1.97851563 1.98388672 12"
                    ></polygon>
                </g>
            </svg>
        </div>
    );
};

export const South = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="icon/social/S" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        id="Icon/24px/Layers-Copy-5"
                        transform="translate(17.000000, 13.646447) rotate(-45.000000) translate(-17.000000, -13.646447) translate(9.000000, 7.146447)"
                        fill="currentColor"
                    >
                        <polygon
                            id="-↳Color"
                            transform="translate(7.920644, 6.503977) rotate(-270.000000) translate(-7.920644, -6.503977) "
                            points="7.92064393 -1.4126894 1.67064393 13.8289773 2.2623106 14.4206439 7.92064393 11.9206439 13.5789773 14.4206439 14.1706439 13.8289773"
                        ></polygon>
                    </g>
                    <path
                        d="M5.97265625,12.1777344 C6.84309896,12.1777344 7.56998698,12.0558268 8.15332031,11.8120117 C8.73665365,11.5681966 9.18782552,11.195638 9.50683594,10.6943359 C9.82584635,10.1930339 9.98535156,9.65527344 9.98535156,9.08105469 C9.98535156,8.44759115 9.85205078,7.91552734 9.58544922,7.48486328 C9.31884766,7.05419922 8.94970703,6.71468099 8.47802734,6.46630859 C8.00634766,6.2179362 7.27832031,5.97753906 6.29394531,5.74511719 C5.30957031,5.51269531 4.68977865,5.28938802 4.43457031,5.07519531 C4.23404948,4.90657552 4.13378906,4.70377604 4.13378906,4.46679688 C4.13378906,4.20703125 4.24088542,3.99967448 4.45507812,3.84472656 C4.78776042,3.6031901 5.24804688,3.48242188 5.8359375,3.48242188 C6.40559896,3.48242188 6.83284505,3.59521484 7.11767578,3.82080078 C7.40250651,4.04638672 7.58821615,4.41666667 7.67480469,4.93164062 L7.67480469,4.93164062 L9.69824219,4.84277344 C9.66634115,3.92220052 9.33251953,3.18619792 8.69677734,2.63476562 C8.06103516,2.08333333 7.11425781,1.80761719 5.85644531,1.80761719 C5.08626302,1.80761719 4.4288737,1.92382812 3.88427734,2.15625 C3.33968099,2.38867188 2.9226888,2.72705078 2.63330078,3.17138672 C2.34391276,3.61572266 2.19921875,4.09309896 2.19921875,4.60351562 C2.19921875,5.39648438 2.50683594,6.0686849 3.12207031,6.62011719 C3.55957031,7.01204427 4.32063802,7.34244792 5.40527344,7.61132812 C6.2483724,7.82096354 6.78841146,7.96679688 7.02539062,8.04882812 C7.37174479,8.171875 7.61442057,8.31656901 7.75341797,8.48291016 C7.89241536,8.6492513 7.96191406,8.85091146 7.96191406,9.08789062 C7.96191406,9.45703125 7.79671224,9.77945964 7.46630859,10.0551758 C7.13590495,10.3308919 6.64485677,10.46875 5.99316406,10.46875 C5.37792969,10.46875 4.88916016,10.3138021 4.52685547,10.0039062 C4.16455078,9.69401042 3.92415365,9.20865885 3.80566406,8.54785156 L3.80566406,8.54785156 L1.83691406,8.73925781 C1.96907552,9.86035156 2.37467448,10.7137044 3.05371094,11.2993164 C3.7327474,11.8849284 4.70572917,12.1777344 5.97265625,12.1777344 Z"
                        id="S"
                        fill="currentColor"
                        fillRule="nonzero"
                        transform="translate(5.911133, 6.992676) rotate(-360.000000) translate(-5.911133, -6.992676) "
                    ></path>
                </g>
            </svg>
        </div>
    );
};

export const East = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="icon/social/E" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        id="Icon/24px/Layers-Copy-5"
                        transform="translate(17.000000, 13.646447) rotate(-45.000000) translate(-17.000000, -13.646447) translate(9.000000, 7.146447)"
                        fill="currentColor"
                    >
                        <polygon
                            id="-↳Color"
                            transform="translate(7.920644, 6.503977) rotate(-270.000000) translate(-7.920644, -6.503977) "
                            points="7.92064393 -1.4126894 1.67064393 13.8289773 2.2623106 14.4206439 7.92064393 11.9206439 13.5789773 14.4206439 14.1706439 13.8289773"
                        ></polygon>
                    </g>
                    <polygon
                        id="E"
                        fill="currentColor"
                        fillRule="nonzero"
                        transform="translate(6.160645, 6.989258) rotate(-360.000000) translate(-6.160645, -6.989258) "
                        points="9.97167969 12 9.97167969 10.3115234 4.37304687 10.3115234 4.37304687 7.58398438 9.40429687 7.58398438 9.40429687 5.89550781 4.37304687 5.89550781 4.37304687 3.67382813 9.78027344 3.67382813 9.78027344 1.97851563 2.34960937 1.97851563 2.34960937 12"
                    ></polygon>
                </g>
            </svg>
        </div>
    );
};

export const West = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="icon/social/W" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        id="Icon/24px/Layers-Copy-5"
                        transform="translate(17.000000, 13.646447) rotate(-45.000000) translate(-17.000000, -13.646447) translate(9.000000, 7.146447)"
                        fill="currentColor"
                    >
                        <polygon
                            id="-↳Color"
                            transform="translate(7.920644, 6.503977) rotate(-270.000000) translate(-7.920644, -6.503977) "
                            points="7.92064393 -1.4126894 1.67064393 13.8289773 2.2623106 14.4206439 7.92064393 11.9206439 13.5789773 14.4206439 14.1706439 13.8289773"
                        ></polygon>
                    </g>
                    <polygon
                        id="W"
                        fill="currentColor"
                        fillRule="nonzero"
                        transform="translate(8.014648, 6.705078) rotate(-360.000000) translate(-8.014648, -6.705078) "
                        points="6.30957031 11 8.01464844 4.578125 9.72558594 11 11.5654297 11 13.6513672 2.41015625 11.9052734 2.41015625 10.5869141 8.41015625 9.08105469 2.41015625 7.01855469 2.41015625 5.44824219 8.31054688 4.15332031 2.41015625 2.37792969 2.41015625 4.42871094 11"
                    ></polygon>
                </g>
            </svg>
        </div>
    );
};
export const DN = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="icon/social/DN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        id="Icon/24px/Layers-Copy"
                        transform="translate(12.000000, 14.500000) scale(1, -1) rotate(-90.000000) translate(-12.000000, -14.500000) translate(-0.500000, 4.000000)"
                        fill="currentColor"
                    >
                        <g id="Group-20" transform="translate(0.000000, 0.000000)">
                            <g id="Group-21" transform="translate(0.000000, 0.000000)">
                                <g id="Group" transform="translate(4.166667, 0.500000)">
                                    <g
                                        id="Icon/24px/Layers-Copy-5"
                                        transform="translate(10.000000, 10.000000) rotate(-90.000000) translate(-10.000000, -10.000000) "
                                    >
                                        <polygon
                                            id="-↳Color"
                                            points="16.6666667 10 15.4916667 8.825 10.8333333 13.475 10.8333333 3.33333333 9.16666667 3.33333333 9.16666667 13.475 4.51666667 8.81666667 3.33333333 10 10 16.6666667"
                                        ></polygon>
                                    </g>
                                </g>
                                <g
                                    id="Icon/24px/Layers-Copy"
                                    transform="translate(5.000000, 10.666667) rotate(-360.000000) translate(-5.000000, -10.666667) translate(-0.000000, 4.166667)"
                                >
                                    <path
                                        d="M9.27783333,0.499833333 L9.27783333,2.444 C7.13116667,2.444 5.38866667,4.1865 5.38866667,6.33316667 C5.38866667,8.47983333 7.13116667,10.2223333 9.27783333,10.2223333 L9.27783333,10.2223333 L9.27783333,12.1665 C5.38866667,12.1665 2.06783333,9.74816667 0.722,6.33316667 C2.06783333,2.919 5.38866667,0.499833333 9.27783333,0.499833333 L9.27783333,0.499833333 Z M9.278,3.99983333 L9.278,8.6665 C7.98633333,8.6665 6.94466667,7.624 6.94466667,6.33316667 C6.94466667,5.04233333 7.98633333,3.99983333 9.278,3.99983333 L9.278,3.99983333 Z"
                                        id="-↳Color"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
export const UP = (props: { className?: any }) => {
    return (
        <div {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="icon/social/UP" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        id="Icon/24px/Layers-Copy"
                        transform="translate(12.000000, 10.000000) rotate(-90.000000) translate(-12.000000, -10.000000) translate(-0.500000, -0.500000)"
                        fill="currentColor"
                    >
                        <g id="Group-20" transform="translate(0.000000, 0.000000)">
                            <g id="Group-21" transform="translate(0.000000, 0.000000)">
                                <g id="Group" transform="translate(4.166667, 0.500000)">
                                    <g
                                        id="Icon/24px/Layers-Copy-5"
                                        transform="translate(10.000000, 10.000000) rotate(-90.000000) translate(-10.000000, -10.000000) "
                                    >
                                        <polygon
                                            id="-↳Color"
                                            points="16.6666667 10 15.4916667 8.825 10.8333333 13.475 10.8333333 3.33333333 9.16666667 3.33333333 9.16666667 13.475 4.51666667 8.81666667 3.33333333 10 10 16.6666667"
                                        ></polygon>
                                    </g>
                                </g>
                                <g
                                    id="Icon/24px/Layers-Copy"
                                    transform="translate(5.000000, 10.666667) rotate(-360.000000) translate(-5.000000, -10.666667) translate(-0.000000, 4.166667)"
                                >
                                    <path
                                        d="M9.27783333,0.499833333 L9.27783333,2.444 C7.13116667,2.444 5.38866667,4.1865 5.38866667,6.33316667 C5.38866667,8.47983333 7.13116667,10.2223333 9.27783333,10.2223333 L9.27783333,10.2223333 L9.27783333,12.1665 C5.38866667,12.1665 2.06783333,9.74816667 0.722,6.33316667 C2.06783333,2.919 5.38866667,0.499833333 9.27783333,0.499833333 L9.27783333,0.499833333 Z M9.278,3.99983333 L9.278,8.6665 C7.98633333,8.6665 6.94466667,7.624 6.94466667,6.33316667 C6.94466667,5.04233333 7.98633333,3.99983333 9.278,3.99983333 L9.278,3.99983333 Z"
                                        id="-↳Color"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const RasterIcon = (props: { style?: any; className?: any }) => {
    return (
        <div {...props}>
            <Raster style={props.style} className={props.className} />
        </div>
    );
};

export const LayersDuplicate = (props: { className?: any; title?: string }) => {
    return (
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <title>Layers duplicate</title>
            <g id="Layers-duplicate" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                    d="M17.4,21 L4.8,21 C3.81,21 3,20.19 3,19.2 L3,19.2 L3,6.6 L6.6,6.599 L6.6,4.8 C6.6,3.8595 7.331025,3.08145 8.25292875,3.00599625 L8.4,3 L19.2,3 C20.19,3 21,3.81 21,4.8 L21,4.8 L21,15.6 C21,16.59 20.19,17.4 19.2,17.4 L19.2,17.4 L17.4,17.4 L17.4,21 Z M4.8,8.4 L4.8,19.2 L15.6,19.2 L15.6,17.4 L8.4,17.4 C7.4595,17.4 6.68145,16.668975 6.60599625,15.7470712 L6.6,15.6 L6.6,8.4 L4.8,8.4 Z"
                    id="Color"
                    fill="currentColor"
                ></path>
            </g>
        </svg>
    );
};

export const LayerOpacity = (props: { className?: any }) => {
    return (
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <title>Icon/24px/Layers dupli 3</title>
            <g id="Query" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Objects-properties" transform="translate(-617.000000, -167.000000)">
                    <g id="Group-9" transform="translate(95.000000, 109.000000)">
                        <g id="Drillhole-properties-Copy" transform="translate(310.000000, 0.000000)">
                            <g id="Icon/24px/Layers-dupli-3" transform="translate(210.000000, 56.000000)">
                                <path
                                    d="M17.5,15.625 L17.5,4.375 C17.5,3.34375 16.65625,2.5 15.625,2.5 L4.375,2.5 C3.34375,2.5 2.5,3.34375 2.5,4.375 L2.5,15.625 C2.5,16.65625 3.34375,17.5 4.375,17.5 L15.625,17.5 C16.65625,17.5 17.5,16.65625 17.5,15.625 L17.5,15.625 Z"
                                    id="Path"
                                    fill="#FFFFFF"
                                ></path>
                                <path
                                    d="M9.16666667,7.5 L10.8333333,7.5 L10.8333333,9.16666667 L9.16666667,9.16666667 L9.16666667,7.5 Z M7.5,9.16666667 L9.16666667,9.16666667 L9.16666667,10.8333333 L7.5,10.8333333 L7.5,9.16666667 Z M10.8333333,9.16666667 L12.5,9.16666667 L12.5,10.8333333 L10.8333333,10.8333333 L10.8333333,9.16666667 Z M12.5,7.5 L14.1666667,7.5 L14.1666667,9.16666667 L12.5,9.16666667 L12.5,7.5 Z M5.83333333,7.5 L7.5,7.5 L7.5,9.16666667 L5.83333333,9.16666667 L5.83333333,7.5 Z M15.8333333,2.5 L4.16666667,2.5 C3.25,2.5 2.5,3.25 2.5,4.16666667 L2.5,15.8333333 C2.5,16.75 3.25,17.5 4.16666667,17.5 L15.8333333,17.5 C16.75,17.5 17.5,16.75 17.5,15.8333333 L17.5,4.16666667 C17.5,3.25 16.75,2.5 15.8333333,2.5 L15.8333333,2.5 Z M7.5,15 L5.83333333,15 L5.83333333,13.3333333 L7.5,13.3333333 L7.5,15 L7.5,15 Z M10.8333333,15 L9.16666667,15 L9.16666667,13.3333333 L10.8333333,13.3333333 L10.8333333,15 L10.8333333,15 Z M14.1666667,13.3333333 L14.1666667,15 L12.5,15 L12.5,13.3333333 L14.1666667,13.3333333 Z M15.8333333,10.8333333 L15.8333333,12.5 L14.1666667,12.5 L14.1666667,10.8333333 L15.8333333,10.8333333 Z M5.83333333,12.5 L4.16666667,12.5 L4.16666667,10.8333333 L5.83333333,10.8333333 L5.83333333,9.16666667 L4.16666667,9.16666667 L4.16666667,4.16666667 L15.8333333,4.16666667 L15.8333333,9.16666667 L14.1666667,9.16666667 L14.1666667,10.8333333 L12.5,10.8333333 L12.5,12.5 L10.8333333,12.5 L10.8333333,10.8333333 L9.16666667,10.8333333 L9.16666667,12.5 L7.5,12.5 L7.5,10.8333333 L5.83333333,10.8333333 L5.83333333,12.5 Z"
                                    id="-↳Color"
                                    fill="#434343"
                                ></path>
                                <path
                                    d="M17.5,15.625 L17.5,4.375 C17.5,3.34375 16.65625,2.5 15.625,2.5 L4.375,2.5 C3.34375,2.5 2.5,3.34375 2.5,4.375 L2.5,15.625 C2.5,16.65625 3.34375,17.5 4.375,17.5 L15.625,17.5 C16.65625,17.5 17.5,16.65625 17.5,15.625 L17.5,15.625 Z"
                                    id="Path"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const MoveFolder = (props: { className?: any }) => {
    return (
        <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <title>0AD5BFDE-2C45-4F25-A122-BF05B5B11213</title>
            <g id="MVP-Sets/Folders" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="4DV_Folder-2" transform="translate(-111.000000, -152.000000)" fill="#434343">
                    <g
                        id="Dropdown/List/Dense/No-Scroll/3-Line-Items-Copy-2"
                        transform="translate(101.000000, 137.000000)"
                    >
                        <g id="2️⃣-Line-item" transform="translate(0.000000, 8.000000)">
                            <g id="📍Icon" transform="translate(10.000000, 7.000000)">
                                <path
                                    d="M15,4.5 L9,4.5 L7.5,3 L3,3 C2.1675,3 1.5075,3.6675 1.5075,4.5 L1.5,13.5 C1.5,14.3325 2.1675,15 3,15 L15,15 C15.8325,15 16.5,14.3325 16.5,13.5 L16.5,6 C16.5,5.1675 15.8325,4.5 15,4.5 L15,4.5 Z M11.0769231,12 L11.0769231,10.3928571 L6.92307692,10.3928571 L6.92307692,12 L4.5,9.75 L6.92307692,7.5 L6.92307692,9.10714286 L11.0769231,9.10714286 L11.0769231,7.5 L13.5,9.75 L11.0769231,12 L11.0769231,12 Z"
                                    id="-↳Color"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const MeshIcon = (props: { className?: any }) => {
    return (
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <title>icon_Mesh-sq</title>
            <g id="icon_Mesh-sq" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                <path
                    d="M20,3 C20.5522847,3 21,3.44771525 21,4 L21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 L20,3 Z M8.21724341,15.3705457 L7.96366193,15.4461749 C7.33573188,15.6445077 6.73148833,15.9194165 6.16446016,16.2662968 L5.85894417,16.4626142 L4,17.715 L4,20 L7.375,20 L7.50841379,18.5576176 C7.60879072,17.4673325 7.84751545,16.3965072 8.21724341,15.3705457 Z M9.90498267,15.0855095 C9.72978738,15.0962514 9.55530398,15.1126829 9.3817835,15.1347184 C8.96491894,16.1282033 8.6846474,17.172588 8.54890968,18.2410764 L8.50420257,18.6492947 L8.38,20 L13.809,20 L13.9709313,19.1222556 C14.1481386,18.1574784 14.3791273,17.203973 14.6626204,16.2661617 C14.6504317,16.2612433 14.6368448,16.2548061 14.6232676,16.2483455 L14.2032464,16.0393957 L14.0728832,15.9716752 C12.7857293,15.3030299 11.3468611,14.9971024 9.90498267,15.0855095 Z M15.5890611,16.6622443 L15.530688,16.8572102 C15.3564201,17.4607192 15.204652,18.0707251 15.0757476,18.6859682 L14.9544779,19.3029104 L14.826,20 L20,20 L20,17.567 L19.101283,17.4837346 C17.8976042,17.3707065 16.7165216,17.0938267 15.5890611,16.6622443 Z M17.2640009,11.0341609 L17.2591274,11.0852467 C17.1542404,11.9899489 16.9453264,12.8806323 16.6358245,13.7394411 L16.4897706,14.1236932 L16.3468968,14.4808115 C16.1933858,14.8645179 16.0493802,15.2517548 15.9149832,15.6421647 C16.8342413,15.9991762 17.7920337,16.2431893 18.7690254,16.3697806 L19.197512,16.417644 L20,16.492 L20,11.66 L19.6516741,11.5950213 C18.8475181,11.4442847 18.0508472,11.2571014 17.2640009,11.0341609 Z M9.67087112,9.0707507 L9.81471615,9.06769821 C8.53935646,9.06769821 7.29264797,9.43826215 6.21916911,10.132746 L5.95449202,10.3130882 L4,11.714 L4,16.432 L5.28010049,15.5695212 C6.32740225,14.8633651 7.50089295,14.383455 8.72830263,14.1543885 L8.85750776,13.8912681 L8.92076257,13.7670713 C9.54531496,12.5408025 9.83106854,11.1699957 9.74849128,9.79632103 C9.73385058,9.55277252 9.70789454,9.31066808 9.67087112,9.0707507 Z M10.6835965,9.10166559 L10.717972,9.37939334 C10.7299374,9.49801417 10.7395174,9.61701103 10.7466893,9.73631522 C10.8327786,11.1684122 10.5644101,12.5977493 9.96781734,13.8984797 L9.911,14.013 L10.1887786,14.0022938 C11.5752163,13.970954 12.9505276,14.2611192 14.2108161,14.8506992 L14.6796187,15.0854022 L14.9949062,15.243046 C15.0558162,15.0677986 15.118591,14.8931716 15.183222,14.7191951 L15.4184438,14.1093615 L15.5613177,13.7522432 C15.9479361,12.7858764 16.1929069,11.7706012 16.2901773,10.7378417 C15.8708142,10.6022814 15.4562145,10.4565266 15.0450867,10.3006607 L14.4070641,10.0495148 L14.0334384,9.89696862 C12.9612972,9.4592285 11.8316149,9.19155866 10.6835965,9.10166559 Z M20,4 L14.967,4 L15.9898639,5.45542071 C16.8672274,6.70439115 17.3380076,8.1935778 17.3380076,9.71991126 L17.3347282,9.94517025 C17.9489066,10.1247492 18.5694741,10.281615 19.1952197,10.4154109 L19.8406794,10.5448904 L20,10.574 L20,4 Z M7.179,4 L4,4 L4,10.409 L5.35310398,9.43941054 C6.55455605,8.57810409 7.96847256,8.08379027 9.4297113,8.00974746 C9.24431727,7.38909845 8.98095957,6.7919205 8.64556937,6.23273287 L8.46219784,5.9416684 L7.179,4 Z M13.745,4 L8.377,4 L9.29639707,5.39020522 C9.83151505,6.19967903 10.22754,7.08828043 10.4722033,8.01924396 C11.6828672,8.08334199 12.878376,8.32983427 14.0200445,8.74971958 L14.4220583,8.90566108 L14.7956841,9.05820721 C15.3034921,9.26553805 15.8172104,9.45662944 16.3360822,9.63125832 L16.3380076,9.71991126 C16.3380076,8.50089914 15.9909395,7.30927236 15.34049,6.28322162 L15.1715824,6.03023841 L13.745,4 Z"
                    id="Rectangle"
                    fill="#3D4F61"
                ></path>
            </g>
        </svg>
    );
};

export { PointCloud, BlockModel, Mesh, MeshSet, Vector, DrillHoles, Raster };
